/* eslint-disable import/prefer-default-export */

// Keywords para detección móvil
const MOBILE_KEYWORDS = [
  'mobile', 'android', 'iphone', 'ipod', 'blackberry', 
  'windows phone', 'iemobile', 'opera mini', 'opera mobi'
];

const TABLET_KEYWORDS = ['ipad', 'tablet', 'kindle', 'silk', 'playbook'];

export const isMobile = () => {
  const userAgent = (navigator.userAgent || window.opera).toLowerCase();
  
  // Excluir tablets
  const isTablet = TABLET_KEYWORDS.some(keyword => userAgent.includes(keyword));
  if (isTablet) return false;
  
  // Detectar móviles
  return MOBILE_KEYWORDS.some(keyword => userAgent.includes(keyword));
};

export const getMobileOperatingSystem = () => {
  const userAgent = window.navigator.userAgent || window.opera;
  const lowerUA = userAgent.toLowerCase();

  // Huawei debe ir primero porque su UA también contiene "android"
  if (lowerUA.includes('huawei')) {
    return 'harmonyOS';
  }

  if (lowerUA.includes('windows phone')) {
    return 'windowsPhone';
  }

  if (lowerUA.includes('android')) {
    return 'android';
  }

  // iOS detection - regex simple y segura
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

export const getMobileStore = () => {
  const os = getMobileOperatingSystem();
  
  switch (os) {
    case 'harmonyOS':
      return 'appGallery';
    case 'windowsPhone':
      return 'microsofotStore';
    case 'android':
      return 'googlePlay';
    case 'iOS':
      return 'appStore';
    default:
      return 'unknown';
  }
};

export const getLinkStore = (idOrName, systemName) => {
  switch (systemName) {
    case 'harmonyOS':
      return `https://appgallery.huawei.com/app/${idOrName}`;
    case 'android':
      return `https://play.google.com/store/apps/details?id=${idOrName}`;
    case 'iOS':
      return `https://apps.apple.com/cl/app/${idOrName}`;
    default:
      return '';
  }
};